import { render, staticRenderFns } from "./articlelist.vue?vue&type=template&id=4e3b37aa&scoped=true"
import script from "./articlelist.vue?vue&type=script&lang=js"
export * from "./articlelist.vue?vue&type=script&lang=js"
import style0 from "./articlelist.vue?vue&type=style&index=0&id=4e3b37aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3b37aa",
  null
  
)

export default component.exports